var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5638 74.359C63.1846 74.359 71.7945 65.7491 71.7945 55.1282C71.7945 44.5074 63.1846 35.8975 52.5638 35.8975C41.9429 35.8975 33.333 44.5074 33.333 55.1282C33.333 65.7491 41.9429 74.359 52.5638 74.359Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7949 20.5128L30.7693 20.5128",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2306 83.3334L80.769 83.3334C82.4691 83.3334 84.0996 82.658 85.3018 81.4558C86.5039 80.2537 87.1793 78.6232 87.1793 76.9231L87.1793 33.3334C87.1793 31.6333 86.5039 30.0028 85.3018 28.8006C84.0996 27.5985 82.4691 26.9231 80.769 26.9231H69.2306L61.5383 15.3846L43.5895 15.3846L35.8972 26.9231L19.2306 26.9231C17.5305 26.9231 15.9 27.5985 14.6978 28.8006C13.4957 30.0028 12.8203 31.6333 12.8203 33.3334L12.8203 76.9231C12.8203 78.6232 13.4957 80.2537 14.6978 81.4558C15.9 82.658 17.5305 83.3334 19.2306 83.3334Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0254 55.1283C41.0254 52.0681 42.241 49.1333 44.4049 46.9694C46.5688 44.8055 49.5037 43.5898 52.5639 43.5898",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 42.3077C26.7702 42.3077 28.2052 40.8727 28.2052 39.1026C28.2052 37.3324 26.7702 35.8975 25.0001 35.8975C23.2299 35.8975 21.7949 37.3324 21.7949 39.1026C21.7949 40.8727 23.2299 42.3077 25.0001 42.3077Z",
    fill: "#171A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera31);
export default __webpack_public_path__ + "static/media/Camera 3 1.401a4e1dfc8a791e7941712d128c3e5a.svg";
export { ForwardRef as ReactComponent };